import BoasVindasDespesasView from "../../components/gestaoOrcamentaria/BoasVindasDespesasView";

export default function BoasVindasDespesas() {
  return <BoasVindasDespesasView />;
}
